import { Card, CardHeader, Typography, Button } from "@mui/material";
import React from "react";
import { BsCashStack } from "react-icons/bs";



const CashHeader = () => {

  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h4" component="div">
            الكاش
          </Typography>
        }
        avatar={<BsCashStack size={20} />}
      />
    </Card>
  );
};

export default CashHeader;
